<template>
  <div style="overflow:hidden" 	id='cancelPopover'>
	<!-- 编辑习题 -->
	<el-dialog
		title="编辑习题"
		:visible.sync="creat_topic_dia_eidt"
		custom-class='homework_edit_choose_topic homework_creat_choose_topic'
	
		>
		 
			<div  style="height:65vh;overflow:auto;background:white">	
				<div  class="creat_topic_dia_list_item" v-for="(item, index) in creat_topic_dia_lsit_edit" :key="index">
					<div class="creat_topic_dia_list_item_head">
						<div>
							<el-popover
								placement="bottom"
								trigger="click"
								popper-class="area_popper_course"
								>
								<div slot="reference" class='course_creat_sort_btn' style="cursor: pointer;">{{item.type_name||change_type_name(item.type_id)}} <i :class="creat_poper_show?'el-icon-caret-top':'el-icon-caret-bottom'"></i></div>
								<div class='course_creat_sort_options'>
									<div v-if="index_type!=0" v-for="(item_type,index_type) in question_type" :key="index_type" :class="{color_active:item.type_name==item_type.n}"  @click="change_creat_topic_dia_topic_type(item,item_type,'edit_1')">{{item_type.n}}</div>
								</div>
							</el-popover>
						</div>
						<div>
							<el-popover
								placement="bottom"
								trigger="click"
								popper-class="area_popper_course"
								>
								<div slot="reference" class='course_creat_sort_btn' style="cursor: pointer;">{{item.level_name||change_level_name(item.level)}} <i :class="creat_poper_show?'el-icon-caret-top':'el-icon-caret-bottom'"></i></div>
								<div class='course_creat_sort_options'>
									<div v-if="index_level!=0" v-for="(item_level,index_level) in question_level" :key="index_level" :class="{color_active:item.level_name==item_level.name}"  @click="change_creat_topic_dia_topic_level(item,item_level,'edit_1')">{{item_level.name||''}}</div>
								</div>
							</el-popover>

						</div>
						<!-- <div @click="creat_topic_dia_list_item_head_del(i)" class="creat_topic_dia_list_item_head_del"><img src="../../assets/images/course_2.0/返回.png" alt=""></div> -->
					</div>
					<div @click="change_topic_content_answer_analysis('edit_1',index,'content')" class="creat_topic_dia_topic_content" v-html="item.content">
						
					</div>
					<div>
						<div class="creat_topic_dia_topic_answer_title">正确答案</div> 
						<!-- 判断题 -->
						<div v-if="item.is_unique&&item.is_unique=='A|B'">
							<div class="creat_topic_dia_topic_answer_choice">
								<div @click="change_creat_topic_dia_topic_answer_choice(index,'A','edit_1')" :style="{background:item.answer[0]=='A'?'#69B4FF':''}"><span class="el-icon-check"></span></div>
								<div @click="change_creat_topic_dia_topic_answer_choice(index,'B','edit_1')" :style="{background:item.answer[0]=='B'?'#69B4FF':''}" ><span class="el-icon-close"></span></div>
							</div>
						
						</div>
						<!-- 选择题 -->
						<div v-else-if="item.is_unique&&(item.is_unique).indexOf('|')!=-1">
							<div class="creat_topic_dia_topic_answer_choice">
								<div @click="change_creat_topic_dia_topic_answer_choice(index,item_answer,'edit_1')" :style="{background:item.answer==item_answer[0]?'#69B4FF':''}" v-for="(item_answer,index_answer) in (item.is_unique).split('|')" :key="index_answer">
									{{item_answer}}
								</div>
								
							</div>
						</div>
						<!-- 多选题 -->
						<div v-else-if="item.is_unique&&(item.is_unique).indexOf('&')!=-1">
							<div class="creat_topic_dia_topic_answer_choice">
								<div @click="change_creat_topic_dia_topic_answer_choice_more(index,item_answer,'edit_1')" :style="{background:item.answer.indexOf(item_answer)!=-1?'#69B4FF':''}" v-for="(item_answer,index_answer) in (item.is_unique).split('&')" :key="index_answer">
									{{item_answer}}
								</div>
								
							</div>
						</div>
						<!-- 主观题 -->
						<div v-else>
							<div v-html="item.answer" class="creat_topic_dia_topic_analysis" @click="change_topic_content_answer_analysis('edit_1',index,'answer')">
							
							</div>
						</div>
					</div>
					<div>
						<div class="creat_topic_dia_topic_answer_title">答案解析</div>
						<div class="creat_topic_dia_topic_analysis" v-html="item.analyzing"  @click="change_topic_content_answer_analysis('edit_1',index,'analysis')">
						
						</div>
					</div>
				</div>
				
				</div>
				<span slot="footer" class="dialog-footer"  >
					<el-button @click="creat_topic_dia_eidt = false">取 消</el-button>
					<span style="opacity:0">空格空格空格空格</span>
					<el-button type="primary"  @click="confirm_edit_topic_edit_1">确定</el-button>
					
				</span>

		</el-dialog>
	  	<el-dialog
		title="编辑习题"
		:visible.sync="edit_topic_dia"
		custom-class='homework_edit_choose_topic homework_creat_choose_topic'
		
		>
		
		
		<div style="height:65vh">	 
			<ifram
			defaultMsg=''
			content=''
			ref="mychild_edit"
			class="edit_txt_content_ifarm "
			>
			</ifram>
		</div>
	
		
		<span slot="footer" class="dialog-footer"  >
			<el-button @click="edit_topic_dia = false">取 消</el-button>
			<span style="opacity:0">空格空格空格空格</span>
			<el-button type="primary"  @click="confirm_edit_topic">确定</el-button>
			
		</span>

		</el-dialog>
	  <!-- 选择习题 -->
	  	<el-dialog
			title="选择题库"
			:visible.sync="choose_topic_dia"
			custom-class='homework_edit_choose_topic'
			>
			<div class="choose_topic_box">
				<div class="content_head">
					<ul class='course_type_box'>
						<li :key="index" v-for="(item,index) in tab_list" @click="switchTab(index,item)">
						<div :style="{'color':index===tab_active?'#69B4FF':'#333333'}">{{item.name}}</div>
						<div :style="{'opacity':index===tab_active?1:0}" class="course_type_line"></div>
						</li>
					</ul>
				</div>
				<div class="topic_type_list">
					<div class="topic_type_list_item_box">
						<div @click="choose_type(item,index)"  :class="index===topic_type?'topic_type_active':''" v-for="(item,index) in question_type" :key="index">
							{{item.n}}
						</div>
					</div>
					<div class="topic_type_list_item_box">
						<div  @click="choose_level(item,index)" :class="index===topic_level?'topic_type_active':''" v-for="(item,index) in question_level" :key="index">
							{{item.name}}
						</div>
					</div>
					
				</div>
				<div class='topic_content'>
					<div class='course_box_head'>
						<div class="course_search" style="opacity:0">
						<el-input placeholder="请输入关键词" v-model="search_name" class="input-with-select">
							<el-button slot="append" icon="el-icon-search" style='border-radius:50%'></el-button>
						</el-input>
						</div>
						
						<div class="course_creat_sort">
						<div >
							已选择 <span style="color:#54A9FD">{{choosed_topic_list.length}}</span> 道题 <span style="opacity:0">111</span>
						</div>
						<div>
						
							<el-popover
							placement="bottom"
							trigger="click"
							popper-class="area_popper_course"
							v-model='popover_sort_show'
							>
							<div slot="reference" class='course_creat_sort_btn' style="cursor: pointer;">{{sort_time}}-{{sort_type}} <i :class="popover_sort_show?'el-icon-caret-top':'el-icon-caret-bottom'"></i></div>
							<div class='course_creat_sort_options'>
								<div class='course_creat_sort_options_disable'>查看范围</div>
								<div :class="{color_active:sort_time=='全部'}" @click="change_sort_time('全部')">全部</div>
								<div :class="{color_active:sort_time=='最近一周'}" @click="change_sort_time('最近一周')">最近一周</div>
								<div :class="{color_active:sort_time=='最近一月'}" @click="change_sort_time('最近一月')">最近一月</div>
								<div :class="{color_active:sort_time=='最近一年'}" @click="change_sort_time('最近一年')">最近一年</div>
								<div class='course_creat_sort_options_disable'>筛选排序</div>
								<div :class="{color_active:sort_type=='时间最新'}" @click="change_sort_type('时间最新')">时间最新</div>
								<div :class="{color_active:sort_type=='时间最早'}" @click="change_sort_type('时间最早')">时间最早</div>
								<div :class="{color_active:sort_type=='热度最高'}" @click="change_sort_type('热度最高')">热度最高</div>
							</div>
							</el-popover>
						</div>
						
						</div>
						
					</div>
					<div class="topic_list">
						<div @click="item.answer_show=!item.answer_show" v-for="(item ,index) in questionList" :key="index" class='topic_list_item'>
							<div class="add_topic">
								<div @click.stop="remove_topic(item)" v-if="is_in_arr(item.uuid)">已添加</div>
								<div @click.stop="add_topic(item)" v-else><img src="../../assets/images/course_2.0/添加_homework.png" alt=""></div>
							</div>
							<div class="topic_content_html" v-html="item.content"></div>
							<div class="topic_answer_analyzing" v-if="item.answer_show">
								<div>[答案]</div>
								<div v-html="item.answer"></div>
								<div>[解析]</div>
								<div v-html="item.analyzing"></div>
							</div>
							<div class="topic_info">
								<div>题型：{{change_topic_type(item.type_id)}}</div>
								<div>难度：<span style="color:#69B4FF">{{item.level}}</span> 星</div>
								<div>热度：<span style="color:#69B4FF">{{item.heat}}</span></div>
								<!-- <div>收藏：{{item.heat}}次</div> -->
								<div>创建时间：{{item.createtime}}</div>
								<div>创建人：{{item.teacher_name}}</div>	
							</div>
						</div>
						
					</div>
					 <div class="course_page" >
						<el-pagination background layout="prev, pager, next" :page-size='12' :total='getQs_total'
							@current-change='changePage' :current-page='getQs_pageNum'>
						</el-pagination>
					</div>
				</div>
			</div>
		</el-dialog>
	<!-- 富文本生成习题 -->
		<el-dialog
		title="上传习题"
		:visible.sync="creat_topic_dia"
		custom-class='homework_edit_choose_topic homework_creat_choose_topic'
		>
		 <el-tabs v-model="creat_topic_dia_active" >
			<el-tab-pane label="创建习题" name="first">
				<div style="height:65vh">	 
					<ifram
					defaultMsg=''
					content=''
					ref="mychild"
					class="edit_txt_content_ifarm "
					>
					</ifram>
				</div>
			</el-tab-pane>
			<el-tab-pane label="习题列表" name="second">
				<div style="height:65vh;overflow:auto;background:white">	
					<draggable
						v-model="creat_topic_dia_lsit"
						@start="drag=true"
						@end="drag=false"
						group='people'
						animation=150
						ghostClass='sortable-ghost'
						chosenClass='chosenClass'
						
						>
						<transition-group> 
							<div :style="{'border-color':creat_topic_dia_lsit_no_success.indexOf(index)==-1?'':'red'}" class="creat_topic_dia_list_item" v-for="(item, index) in creat_topic_dia_lsit" :key="index">
								<div class="creat_topic_dia_list_item_head">
									<div>
										<el-popover
											placement="bottom"
											trigger="click"
											popper-class="area_popper_course"
											>
											<div slot="reference" class='course_creat_sort_btn' style="cursor: pointer;">{{item.type_name}} <i :class="creat_poper_show?'el-icon-caret-top':'el-icon-caret-bottom'"></i></div>
											<div class='course_creat_sort_options'>
												<div v-if="index_type!=0" v-for="(item_type,index_type) in question_type" :key="index_type" :class="{color_active:item.type_name==item_type.n}"  @click="change_creat_topic_dia_topic_type(item,item_type)">{{item_type.n}}</div>
											</div>
										</el-popover>
									</div>
									<div>
										<el-popover
											placement="bottom"
											trigger="click"
											popper-class="area_popper_course"
											>
											<div slot="reference" class='course_creat_sort_btn' style="cursor: pointer;">{{item.level_name}} <i :class="creat_poper_show?'el-icon-caret-top':'el-icon-caret-bottom'"></i></div>
											<div class='course_creat_sort_options'>
												<div v-if="index_level!=0" v-for="(item_level,index_level) in question_level" :key="index_level" :class="{color_active:item.level_name==item_level.name}"  @click="change_creat_topic_dia_topic_level(item,item_level)">{{item_level.name||''}}</div>
											</div>
										</el-popover>

									</div>
									<div @click="creat_topic_dia_list_item_head_del(index)" class="creat_topic_dia_list_item_head_del"><img src="../../assets/images/course_2.0/删除.png" alt=""></div>
								</div>
								<div @click="change_topic_content_answer_analysis('new',index,'content')" class="creat_topic_dia_topic_content" v-html="item.content">
									
								</div>
								<div>
									<div class="creat_topic_dia_topic_answer_title">正确答案</div> 
									<!-- 判断题 -->
									<div v-if="item.is_unique&&item.is_unique=='A|B'">
										<div class="creat_topic_dia_topic_answer_choice">
											<div @click="change_creat_topic_dia_topic_answer_choice(index,'A')" :style="{background:item.answer[0]=='A'?'#69B4FF':''}"><span class="el-icon-check"></span></div>
											<div @click="change_creat_topic_dia_topic_answer_choice(index,'B')" :style="{background:item.answer[0]=='B'?'#69B4FF':''}" ><span class="el-icon-close"></span></div>
										</div>
									
									</div>
									<!-- 选择题 -->
									<div v-else-if="item.is_unique&&(item.is_unique).indexOf('|')!=-1">
										<div class="creat_topic_dia_topic_answer_choice">
											<div @click="change_creat_topic_dia_topic_answer_choice(index,item_answer)" :style="{background:item.answer==item_answer[0]?'#69B4FF':''}" v-for="(item_answer,index_answer) in (item.is_unique).split('|')" :key="index_answer">
												{{item_answer}}
											</div>
											
										</div>
									</div>
									<!-- 多选题 -->
									<div v-else-if="item.is_unique&&(item.is_unique).indexOf('&')!=-1">
										<div class="creat_topic_dia_topic_answer_choice">
											<div @click="change_creat_topic_dia_topic_answer_choice_more(index,item_answer)" :style="{background:item.answer.indexOf(item_answer)!=-1?'#69B4FF':''}" v-for="(item_answer,index_answer) in (item.is_unique).split('&')" :key="index_answer">
												{{item_answer}}
											</div>
											
										</div>
									</div>
									<!-- 主观题 -->
									<div v-else>
										<div v-html="item.answer" class="creat_topic_dia_topic_analysis" @click="change_topic_content_answer_analysis('new',index,'answer')">
										
										</div>
									</div>
								</div>
								<div>
									<div class="creat_topic_dia_topic_answer_title">答案解析</div>
									<div class="creat_topic_dia_topic_analysis" v-html="item.analyzing"  @click="change_topic_content_answer_analysis('new',index,'analysis')">
									
									</div>
								</div>
							</div>
						</transition-group>
					</draggable>
				</div>
			</el-tab-pane>
			
		</el-tabs>
		
		<span slot="footer" class="dialog-footer"  >
			<el-button @click="creat_topic_dia = false">取 消</el-button>
			<span style="opacity:0">空格空格空格空格</span>
			<el-button type="primary" v-if="creat_topic_dia_active=='first'" @click="build_new_topic_list()">生成习题列表</el-button>
			<el-button type="primary" v-if="creat_topic_dia_active=='second'" @click="build_new_topice_save()">确定</el-button>
		</span>

		</el-dialog>
       <div class="wrapper_all">
        <div class="wrapper">
			<div class="head">
				<div class="head_top">
					<div @click="$router.go(-1)"><img src="../../assets/images/course_2.0/返回.png" alt=""></div>
					<div>文本建题</div>
					<div class="sav_homework" @click="save_homework()">保存</div>
				</div>
				<div class="head_foot">
					<div class='add_course_info_head_course_name' v-if="$route.query.name!='预览'">
						<div class='add_course_info_head_course_name_add_name' style="display:flex;">
							<div>作业名称</div>
							<div><el-input v-model="homework_name" placeholder="请输入作业名称"></el-input></div>
						</div>
						<div>
							<el-popover
								placement="bottom"
								trigger="click"
								popper-class="area_popper"
								v-model='chapter_popover'
							>
							<div slot="reference" >
								<div class="chapter_bar">
									章节：<span style="color:#999999"> {{chapter_name}}</span>
									<span style="opacity:0">11</span>
									<span v-if="!chapter_popover" style="color:#999999" class="el-icon-caret-bottom"></span>
									<span v-else style="color:#999999" class="el-icon-caret-top"></span>
								</div>
								
							</div>
							<div>
								<el-tree :data="SectionData" :props="SectionProps" @node-click="getSectionData" node-key='guid'
									:default-expanded-keys="showNode" highlight-current ref="treeBox">
									<div class="tree_line" slot-scope="{ node }">
										<div>{{ node.label }}</div>
									</div>
								</el-tree>
							</div>
							
						</el-popover>
						</div>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="content_l">
					<div class="content_l_top">
						<div>作业预览</div>
						<div class="get_topic">
							<div @click='choose_topic()'>选择题库</div>
							<div @click="creat_topic()">上传习题</div>
						</div>
					</div>
					<div class="content_topic_list">
						<div v-if="choosed_topic_list_up.length">
							<draggable
								v-model="choosed_topic_list_up"
								@start="drag=false"
								@end="drag=false"
								group='people'
								animation=150
								ghostClass='sortable-ghost'
								chosenClass='chosenClass'
								
								>
								<transition-group  >
									<div  v-for="(data ,i) in choosed_topic_list_up" :key="i" v-if="data.topicList.length">
										
										<el-collapse v-model="activeName" accordion>
  											<el-collapse-item :title="data.name+'('+data.topicList.length+')'" :name='data.name'>

												<draggable
													v-model="data.topicList"
													@start="drag=false"
													@end="drag=false"
													group='people2'
													animation=150
													ghostClass='sortable-ghost'
													chosenClass='chosenClass'
													
													>
													<transition-group >
														<div v-for="(item ,index) in data.topicList" :key="index" class='topic_list_item'>
															<div class="topic_content_html" v-html="(index+1)+'.'+item.content"  @click="item.answer_show=!item.answer_show"></div>
															<div class="topic_answer_analyzing" v-if="item.answer_show">
																<div>[答案]</div>
																<div   v-html="item.answer"></div>
																<div>[解析]</div>
																<div   v-html="item.analyzing"></div>
															</div>
															<div class="topic_info">
																<div>题型：{{change_topic_type(item.type_id)}}</div>
																<div>难度：<span style="color:#69B4FF">{{item.level}}</span> 星</div>
																<div class="topic_info_edit">
																	<div class="topic_info_edit_img" @click="edit_topic_1(item,index,i)"><img src="../../assets/images/course_2.0/编辑.png" alt=""></div>
																	<div @click="del_topic(i,index,item)" class="topic_info_edit_img"><img src="../../assets/images/course_2.0/删除.png" alt=""></div>
																</div>
															</div>
														</div>
													</transition-group>
												</draggable>


											</el-collapse-item>
										</el-collapse>
									</div>
									<!-- <div v-for="(item ,index) in choosed_topic_list" :key="index" class='topic_list_item'>
								
										<div class="topic_content_html" v-html="(index+1)+'.'+item.content"  @click="item.answer_show=!item.answer_show"></div>
										<div class="topic_answer_analyzing" v-if="item.answer_show">
											<div>[答案]</div>
											<div   v-html="item.answer"></div>
											<div>[解析]</div>
											<div   v-html="item.analyzing"></div>
										</div>
										<div class="topic_info">
											<div>题型：{{change_topic_type(item.type_id)}}</div>
											<div>难度：<span style="color:#69B4FF">{{item.level}}</span> 星</div>
											<div class="topic_info_edit">
												<div class="topic_info_edit_img" @click="edit_topic_1(item,index)"><img src="../../assets/images/course_2.0/编辑.png" alt=""></div>
												<div @click="del_topic(index)" class="topic_info_edit_img"><img src="../../assets/images/course_2.0/删除.png" alt=""></div>
											</div>
										</div>
									</div> -->
								</transition-group>
							</draggable>



							<!-- <draggable
								v-model="choosed_topic_list"
								@start="drag=true"
								@end="drag=false"
								group='people'
								animation=150
								ghostClass='sortable-ghost'
								chosenClass='chosenClass'
								
								>
								<transition-group>
									<div v-for="(item ,index) in choosed_topic_list" :key="index" class='topic_list_item'>
								
										<div class="topic_content_html" v-html="(index+1)+'.'+item.content"  @click="item.answer_show=!item.answer_show"></div>
										<div class="topic_answer_analyzing" v-if="item.answer_show">
											<div>[答案]</div>
											<div   v-html="item.answer"></div>
											<div>[解析]</div>
											<div   v-html="item.analyzing"></div>
										</div>
										<div class="topic_info">
											<div>题型：{{change_topic_type(item.type_id)}}</div>
											<div>难度：<span style="color:#69B4FF">{{item.level}}</span> 星</div>
											<div class="topic_info_edit">
												<div class="topic_info_edit_img" @click="edit_topic_1(item,index)"><img src="../../assets/images/course_2.0/编辑.png" alt=""></div>
												<div @click="del_topic(index)" class="topic_info_edit_img"><img src="../../assets/images/course_2.0/删除.png" alt=""></div>
											</div>
										</div>
									</div>
								</transition-group>
							</draggable> -->

						</div>
						<div v-else class="no_list_img">
							
						</div>
					</div>
				</div>
				<div class="conent_r">
					<div class="content_l_top">
						<div>答题卡</div>
						<div class="topic_num">
							{{choosed_topic_list.length}}
						</div>
					</div>
					<div class='content_topic_list'>
						<div style="display:flex;flex-wrap:wrap">
							<div class="content_topic_list_item" v-for="(item,index) in choosed_topic_list" :key="index">
								{{index+1}}
							</div>
						</div>
						
					</div>
				</div>
			</div>
        </div>
      </div>
  </div>
</template>

<script>
import {getNodeCode_topic,getNodeCode} from "../../assets/js/common"
import draggable from "vuedraggable";
import ifram from "../../components/ifarm/ifarm";

export default {
	components: {draggable,ifram},
  data() {
    return {
		activeName:[],
		creat_topic_dia_lsit_edit_index:-1,//编辑习题时候用户来将接口返回的习题赋值到习题列表
		creat_topic_dia_lsit_edit_i:-1,//编辑习题时候用户来将接口返回的习题赋值到习题列表
		creat_topic_dia_eidt:false,
		creat_topic_dia_lsit_edit:[],
		topic_status:2, //习题是否公有 1私密2共享
		edit_topic_dia:false,
		creat_topic_dia_lsit_no_success:[],
		creat_poper_show:false,
		creat_topic_dia_lsit:[],//富文本创建的习题列表
		creat_topic_dia_active:'first',
		creat_topic_dia:false,
		homework_name:"新建作业",
		chapter_name:'请选择章节',
		chapter_code:'',
		chapter_popover:false,
		SectionProps: {
          children: "children",
          label: "name"
		},
		SectionData: [],
		showNode:[],
		topic_list:[],
		topic_num:999,
		choose_topic_dia:false,
		 tab_list: [
          { name: "云题库", id: 1 },
          { name: "学校题库", id: 2 },
          { name: "共享题库", id: 3 },
          { name: "我的题库", id: 4 }
        ],
		tab_active:3,
		question_type: [{ n: "全部题型", id: 0, s: "" }],
      	question_level: [{ name: "全部难度" ,id:0}],
		topic_level:0,
		topic_type:0,
		topic_level_id:0,
		topic_type_id:0,
		popover_sort_show:false,
		starttime_sort:'',
        end_time_sort:'',
        sort_time:'全部',
        sort_type:'时间最新',
		search_name:'',
		getQs_pageNum:1,
		getQs_total:0,
		str_node:'',
		sort:'createtime',
		order:"descending",
		questionList:[],
		getQs_page_size:12,
		choosed_topic_list:[],
		str_hax_all:'',
		homework_list:[],//作业列表 通过路由和上页面传参
		obj:'',//布置作业的其他参数
		choosed_topic_list_up:[]
    };
  },
  //监听路由变化 控制首页背景图

  created() {
	
  },
  mounted() {
	let that=this

	
   this.getSubject(sessionStorage.subject_code)
   this.get_type()
    if(this.$route.params.list){
		this.homework_list=this.$route.params.list
		this.obj=this.$route.params.obj
	}else{
		this.homework_list=[]
	}
	if(this.$route.params.type=='edit'){
		let item=this.$route.params.item
		this.chapter_code=item.chapter_code
		let arr=JSON.parse(item.content)
		let list=[]
		for(let i in arr){
			for(let j in arr[i].topicList){
				list.push(arr[i].topicList[j])
			}
		}
		this.choosed_topic_list_up=JSON.parse(item.content)
		this.choosed_topic_list=list
		console.log(list)
	}
	

  },
  	methods: {
		  //编辑习题题型转
			change_type_name(data){
				// console.log(this.question_type)
				for(let i in this.question_type){
					if(data==this.question_type[i].id){
						return this.question_type[i].n
					}
				}
			},
			change_level_name(data){
				if(data==1){
					return '一星'
				}
				if(data==2){
					return '二星'
				}
				if(data==3){
					return '三星'
				}
				if(data==4){
					return '四星'
				}
				if(data==5){
					return '五星'
				}
			},

		  edit_topic_1(item,index){
			//   console.log(item)
			//   console.log(this.choosed_topic_list)
			let item_temp=JSON.parse(JSON.stringify(item))
			  this.creat_topic_dia_eidt=true
			  let arr=[]
			  arr.push( item_temp)
			  this.creat_topic_dia_lsit_edit=arr
			  this.creat_topic_dia_lsit_edit_index=index
		  },
		  confirm_edit_topic_edit_1(){
			  console.log(this.creat_topic_dia_lsit_edit[0])
			  let item =this.creat_topic_dia_lsit_edit[0]
			    if(typeof(item.answer)=='object'){
         item.answer=item.answer.join()
       }
			//   return
			  let formdata_1={
				  analyzing:item.analyzing,
				  answer:item.answer,
				  content:item.content,
				  from:item.from,
				  is_unique:item.is_unique,
				  level:item.level,
				  school_code:item.school_code,
				  status:item.status,
				  subject_code:item.subject_code,
				  teacher_name:item.teacher_name,
				  type_id:item.type_id,
				  textbook_guid:sessionStorage.text_book_guid
			  }
			   let url
			   
			  if(item.heat>0){
				  url='/school/tiku/batchAddTiku'
			  }else{
				  url='/school/tiku/newEditTiku'
				  formdata_1.id=item.id
			  }
			 
			  this.axios.post(url, formdata_1).then(res => {
				if(res.data.code==1){
					this.$message({
						type:'success',
						message:res.data.msg
					})
					this.choosed_topic_list[this.creat_topic_dia_lsit_edit_index]=res.data.data.data
					this.creat_topic_dia_eidt=false
				}else{
					this.$message({
						type:'error',
						message:res.data.msg
					})
				}
			})

		  },
		//切换  云 学校 我的
		switchTab(index,item){
			this.tab_active = index;
			this.getQs_pageNum = 1;
			if (this.tab_active ==0) {
				this.get_cloud_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 1) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 2) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 3) {
				this.get_my_collect_list(sessionStorage.subject_code);
			}
		},
		//选择习题
		choose_topic(){
			if(this.chapter_code){
				this.choose_topic_dia=true
			}else{
				this.$message({
					type:'error',
					message:'请先选择章节',
					durtion:1500,
					showClose: true,
				})
			}
		},
		getSectionData(data){
		let str=getNodeCode_topic(data,[]).join(',')
		this.str_node=str
		let str_hax_all=getNodeCode(data,[])
		this.str_hax_all=str_hax_all
		//  console.log(data)
			this.chapter_code=data.c
			this.chapter_popover=false
			this.chapter_name=data.name
			if (this.tab_active ==0) {
		this.get_cloud_question_bank_list(sessionStorage.subject_code);
		} else if (this.tab_active == 1) {
			this.get_school_question_bank_list(sessionStorage.subject_code);
		} else if (this.tab_active == 2) {
			this.get_school_question_bank_list(sessionStorage.subject_code);
		} else if (this.tab_active == 3) {
			this.get_my_collect_list(sessionStorage.subject_code);
		}
		},
		//获取教材 章节
		getSubject(code) {
		let formData = new FormData();
		formData.append("subject_code", code);
		this.axios.post("/teacher/subject/gettextbook", formData).then(res => {
			if(res.data.code==1){
				let arr=res.data.data
				for(let i in arr){
					if(arr[i].id==JSON.parse(sessionStorage.userInfo).textbook_code){
					//  console.log(arr[i].chapter_json)
						this.SectionData=JSON.parse(arr[i].chapter_json)
						for(let j in this.SectionData){
							this.showNode.push(this.SectionData[j].guid)
						}
					}
				}
				this.get_my_collect_list(sessionStorage.subject_code);
			}
		});
		},
		//获取教材考点习题类型
		get_type() {
		var code = sessionStorage.subject_code;
		this.axios
			.get("/teacher/subject/getlist?subject_code=" + code)
			.then(res => {
			if (res.data.code == 1) {
				var list = JSON.parse(res.data.data.tiku_type.type_json);
				for (var i = 0; i < list.length; i++) {
				this.question_type.push(list[i]);
				}
				var list1 = res.data.data.difficulty;
				
				for (var i = 0; i < list1.length; i++) {
				this.question_level.push(list1[i]);
				}
				let arr=[]
				let question_type=JSON.parse(JSON.stringify(this.question_type)) 
				question_type.splice(0,1)
				for(let i in question_type){
					arr.push({
						name:question_type[i].n,
						id:question_type[i].id,
						is_unique:question_type[i].s,
						topicList:[]
					})
				}
				// console.log(this.choosed_topic_list_up)
				let arr_ids=[]
				
				for(let i in this.choosed_topic_list_up){
					arr_ids.push(this.choosed_topic_list_up[i].id)	
				}
				for(let i in arr){
				
				
						if(arr_ids.indexOf(arr[i].id)==-1){
						
							this.choosed_topic_list_up.push(arr[i])
						}
			
				}
				this.formatting_topic()
			} else {
				this.$message({
				type: "error",
				message: res.data.msg,
				duration:500,showClose: true
				});
			}
			});
		},
		change_topic_type(id){
			for(let i in this.question_type){
				if(this.question_type[i].id==id){
					return this.question_type[i].n
				}
			}
		},
		choose_type(item,index){
			this.topic_type=index
			this.topic_type_id=item.id
			if (this.tab_active ==0) {
				this.get_cloud_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 1) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 2) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 3) {
				this.get_my_collect_list(sessionStorage.subject_code);
			}
		},
		choose_level(item,index){
			this.topic_level=index
			this.topic_level_id=item.id
			if (this.tab_active ==0) {
				this.get_cloud_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 1) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 2) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 3) {
				this.get_my_collect_list(sessionStorage.subject_code);
			}
		},
		change_sort_time(type){
			this.popover_sort_show=false
			this.sort_time=type
			this.sort_getdata()
		},
		change_sort_type(type){
		this.popover_sort_show=false
		this.sort_type=type
		this.sort_getdata()
		},
		sort_getdata(){
			let timestamp = Date.parse(new Date());
			if(this.sort_time=='全部'){
			this.starttime_sort=''
			this.end_time_sort=''
			}else if(this.sort_time=='最近一周'){
			this.starttime_sort=timestamp-1000*7*24*60*60
			this.end_time_sort=timestamp
			}else if(this.sort_time=='最近一月'){
			this.starttime_sort=timestamp-1000*30*24*60*60
			this.end_time_sort=timestamp
			}else if(this.sort_time=='最近一年'){
			this.starttime_sort=timestamp-1000*365*24*60*60
			this.end_time_sort=timestamp
			}
			if(this.sort_type=='时间最新'){
			this.order = 'descending'
			this.sort = 'createtime'
			}else if(this.sort_type=='时间最早'){
				this.order = 'ascending'
				this.sort = 'createtime'
			}else if(this.sort_type=='热度最高'){
				this.order = 'descending'
				this.sort = 'heat'
			}
			if (this.tab_active ==0) {
			this.get_cloud_question_bank_list(sessionStorage.subject_code);
		} else if (this.tab_active == 1) {
			this.get_school_question_bank_list(sessionStorage.subject_code);
		} else if (this.tab_active == 2) {
			this.get_school_question_bank_list(sessionStorage.subject_code);
		} else if (this.tab_active ==3) {
			this.get_my_collect_list(sessionStorage.subject_code);
		}

		


		},
		changePage(pageNum) {

			this.questionList=[] //回到顶部
			this.getQs_pageNum = pageNum;
			if (this.tab_active == 0) {
				this.get_cloud_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 1) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 2) {
				this.get_school_question_bank_list(sessionStorage.subject_code);
			} else if (this.tab_active == 3) {
				this.get_my_collect_list(sessionStorage.subject_code);
			}
		},
			//获取云题库列表
		get_cloud_question_bank_list(code) {
		
		var formData = new FormData();
		formData.append("subject_code", code);
		// formData.append("chapter_code", this.chapter_code);
		formData.append("current_page", this.getQs_pageNum);
		formData.append("page_size", this.getQs_page_size);
		formData.append("p_uuid", "");
		// formData.append("node_code", this.node_code);
		//   if(this.tab_active2==1){
		//       formData.append("chapter_code", '');
		//       formData.append("node_codes", this.chapter_code);
		//   }else{
			formData.append("chapter_code", this.str_hax_all);
			//   formData.append("node_codes", this.node_code);

		//   }
		formData.append("level", this.topic_level_id);
		formData.append("sort", this.sort);
		formData.append("order", this.order);
			formData.append("start_time", this.starttime_sort);
			formData.append("end_time", this.end_time_sort);
		formData.append("chapterToNode", this.str_node);
		//  formData.append("level", "");
		formData.append("type_id", this.topic_type_id);
		this.axios.post(`/teacher/tiku/getlist`, formData).then(res => {
			// console.log(res.data.data);
			if (res.data.code == 1) {
			// this.change_qs_list(res.data.data.data);
			this.questionList = res.data.data.data;
			this.getQs_total = res.data.data.total;
			} else {
			this.$message({
				type: "error",
				message: res.data.msg,
				duration:500,showClose: true
			});
			}
		});
		},

		//获取学校或共享题库列表
		get_school_question_bank_list(code) {
		var status = "";
		//   var sort = "";
		if (this.tab_active == 2) {
			status = 3;
			// sort = "heat";
		} else if (this.tab_active ==3) {
			status = 2;
			// sort = "createtime";
		}
		var formData = new FormData();
		formData.append("sort", this.sort);
		formData.append("order", this.order);
			formData.append("start_time", this.starttime_sort);
			formData.append("end_time", this.end_time_sort);
		formData.append("status", status);
		//过滤子习题 阅读理解等一些特殊题型用到
		formData.append("p_uuid", "");
		formData.append("chapter_code", this.str_hax_all);
		formData.append("current_page", this.getQs_pageNum);
		formData.append("page_size", this.getQs_page_size);
		formData.append("subject_code", code);
		formData.append("type_id", this.topic_type_id);
		// formData.append("chapter_code", this.chapter_code);
		formData.append("level", this.topic_level_id);
		formData.append("chapterToNode", this.str_node);
		//  formData.append("level", "");
		//	过滤难度等级
		this.axios.post(`/school/tiku/tikuList`, formData).then(res => {
			if (res.data.code == 1) {
			// console.log(res.data.data);
			this.questionList = [];
			this.change_qs_list(res.data.data.data);
			this.questionList = res.data.data.data;
			this.getQs_total = res.data.data.count;
			} else {
			this.$message({
				type: "error",
				message: res.data.msg,
				duration:500,showClose: true
			});
			}
		});
		},
		//获取我的收藏习题列表
		get_my_collect_list(code) {
		//  alert(this.span_act_id)
		var formData = new FormData();
		formData.append("subject_code", code);
		formData.append("type_id", this.topic_type_id);
		formData.append("current_page", this.getQs_pageNum);
		formData.append("page_size", this.getQs_page_size);
		formData.append("level", this.topic_level_id);
			formData.append("start_time", this.starttime_sort);
			formData.append("end_time", this.end_time_sort);
		
		//   if(this.tab_active2==1){
		//       formData.append("chapter_code", '');
		//       formData.append("node_codes", this.chapter_code);
		//   }else{
			formData.append("chapter_code", this.str_hax_all);
		//       formData.append("node_codes", this.node_code);

		//   }
		formData.append("chapterToNode", this.str_node);
		
		formData.append("sort",this.sort);//
		formData.append("order", this.order);
		this.axios
			.post(`/school/Collection_tiku/collectionList`, formData)
			.then(res => {
			if (res.data.code == 1) {
				// console.log(res.data.data.data);
				this.change_qs_list(res.data.data.data);
				this.questionList = [];
				this.questionList = res.data.data.data;
				this.getQs_total = res.data.data.count;
			} else {
				this.$message({
				type: "error",
				message: res.data.msg,
				duration:500,showClose: true
				});
			}
			});
		},
		change_qs_list(questionList) {
			for (var i in questionList) {
				questionList[i].answer_show = false;
				questionList[i].analyzing_show = false;
				
			}
		},

		remove_topic(item){
			for(let i in this.choosed_topic_list){
				if(this.choosed_topic_list[i].uuid==item.uuid){
					this.choosed_topic_list.splice(i,1)
					
				}
			}
			for(let i in this.choosed_topic_list_up){
				for(let j in this.choosed_topic_list_up[i].topicList){
					if(this.choosed_topic_list_up[i].topicList[j].uuid==item.uuid){
						this.choosed_topic_list_up[i].topicList.splice(j,1)
					}
				}
			}
			this.formatting_topic()

		},
		add_topic(item){
			
			this.choosed_topic_list.push(item)
			this.formatting_topic()
		
		},
		//判断是否已添加习题
		is_in_arr(uuid){
			for(let i in this.choosed_topic_list){
				if(this.choosed_topic_list[i].uuid==uuid){
					return true
				}
			}
			return false
		},
		//删除习题
		del_topic(i,index,item){
			 this.$confirm('确定移除该习题？')
			.then(_ => {
				
				this.choosed_topic_list_up[i].topicList.splice(index,1)
				for(let j in this.choosed_topic_list){
					if(this.choosed_topic_list[j].id==item.id){
						this.choosed_topic_list.splice(j,1)
					}
				}
			
				this.formatting_topic()
				
			})
			.catch(_ => {

			})
			
		},
		//富文本生成习题
		creat_topic(){
			this.creat_topic_dia_lsit_no_success=[]
			if(this.chapter_code){
				// this.choose_topic_dia=true
			}else{
				this.$message({
					type:'error',
					message:'请先选择章节',
					durtion:1500,
					showClose: true,
				})
				return
			}
			this.creat_topic_dia=true
		},
		// 生成习题列表
		build_new_topic_list(){
			 let content = this.$refs.mychild.getContent();
			if(!content){
				this.$message({
				message:'习题内容不能为空',
				type:'error',
				duration:500,showClose: true
				})
				return
			}
			let formData = new FormData();
			formData.append("str", content);
			this.axios.post("/school/tiku/split_tikus", formData).then(res => {
				if (res.data.code == 0) {
					this.$message({
						type: "error",
						message: res.data.msg,
						duration:1500,showClose: true
					});
				} else {
					this.$refs.mychild.setContent_exam('');
					let arr=[]
					for(let i in res.data.data){
						arr.push({
							content:res.data.data[i],
							// status:this.status_job ? 1 : 2
							status: this.topic_status,
							type_id:'',
							type_name:"选择题型",
							level:3,
							level_name:'三星',
							answer:''
						})
					}
					this.creat_topic_dia_active='second'
					this.creat_topic_dia_lsit=this.creat_topic_dia_lsit.concat(arr)
					
				} 
			})
				
			
		},
		change_creat_topic_dia_topic_type(item,item_type){
	
			item.type_name=item_type.n
			item.type_id=item_type.id
			item.is_unique=item_type.s
			if(item.is_unique&&item.is_unique=='A|B'){
				item.answer=[]
				item.analyzing=""
			}else if(item.is_unique&&(item.is_unique).indexOf('|')!=-1){
				item.answer=[]
				item.analyzing=""
			}else if(item.is_unique&&(item.is_unique).indexOf('&')!=-1){
				item.answer=[]
				item.analyzing=""
			}else {
				item.answer=""
				item.analyzing=""
			}
			// console.log(item)
			// this.creat_poper_show=false
			this.cancelPopover()
		},
		change_creat_topic_dia_topic_level(item,item_level){
			item.level_name=item_level.name
			item.level=item_level.id
			// this.creat_poper_show=false
			this.cancelPopover()
		},
		cancelPopover(){
			document.getElementById('cancelPopover').click()
		},
		creat_topic_dia_list_item_head_del(i){
			 this.$confirm('确定移除该习题？')
			.then(_ => {
				this.creat_topic_dia_lsit.splice(i,1)
			})
			.catch(_ => {

			})
			
		},

		build_new_topice_save(){
			
			this.creat_topic_dia_lsit_no_success=[]
			if(this.creat_topic_dia_lsit.length){
				let arr=JSON.parse(JSON.stringify(this.creat_topic_dia_lsit)) 
				for(let i in arr){
					if(arr[i].type_id){
					}else{
						this.creat_topic_dia_lsit_no_success.push(Number(i))
					}
					if(arr[i].is_unique){
						if(arr[i].is_unique=='A|B'||(arr[i].is_unique).indexOf('|')!=-1||(arr[i].is_unique).indexOf('&')!=-1){
							if(!arr[i].answer.length){
								this.creat_topic_dia_lsit_no_success.push(Number(i))
							}else{
								arr[i].answer=arr[i].answer.join(',')
							}
						}
						
					}
					arr[i].chapter_code=this.chapter_code
					arr[i].status=this.topic_status
					arr[i].subject_code=sessionStorage.subject_code
					arr[i].teacher_name=JSON.parse(sessionStorage.userInfo).name
					arr[i].from=JSON.parse(sessionStorage.userInfo).school.name
					arr[i].school_code=JSON.parse(sessionStorage.userInfo).school_code
						 arr[i].textbook_guid=sessionStorage.text_book_guid
					// arr[i].answer_show=false

				}
				if(this.creat_topic_dia_lsit_no_success.length){
					this.$message({
						type:'error',
						message:'习题暂未设置完成',
						durtion:1500,
						showClose: true,
					})
					return

				}else{
					///接口生成习题
					let formdata_1={
						batchTikus:arr
					}
					this.axios.post('/school/tiku/batchAddTiku', formdata_1).then(res => {
						if(res.data.code==1){
							this.$message({
								type:'success',
								message:res.data.msg
							})
							for(let i in res.data.data.data){
								res.data.data.data[i].answer_show=false
							}
							this.choosed_topic_list=this.choosed_topic_list.concat(res.data.data.data)
							this.creat_topic_dia_lsit=[]
							this.creat_topic_dia_active='first'
							this.creat_topic_dia=false	
							this.formatting_topic()
						}else{
							this.$message({
								type:'error',
								message:res.data.msg
							})
						}
					})

				}
			}else{
				this.creat_topic_dia=false	
			}
			
		},
		change_creat_topic_dia_topic_answer_choice(index,answer,type){
			// item.answer=answer
			// console.log(answer)
			let arr=[]
			arr.push(answer)
			if(type=='edit_1'){
				this.creat_topic_dia_lsit_edit[0].answer=arr
			}else{
				this.creat_topic_dia_lsit[index].answer=arr

			}

			this.$forceUpdate();
			
		},
		change_creat_topic_dia_topic_answer_choice_more(index,answer,type){
			if(type=='edit_1'){
				if(this.creat_topic_dia_lsit_edit[0].answer.indexOf(answer)!=-1){
					this.creat_topic_dia_lsit_edit[0].answer.splice(this.creat_topic_dia_lsit_edit[0].answer.indexOf(answer),1)
				}else{
					// alert(1)
					this.creat_topic_dia_lsit_edit[0].answer.push(answer)
				}
			}else{
				if(this.creat_topic_dia_lsit[index].answer.indexOf(answer)!=-1){
					this.creat_topic_dia_lsit[index].answer.splice(this.creat_topic_dia_lsit[index].answer.indexOf(answer),1)
				}else{
					// alert(1)
					this.creat_topic_dia_lsit[index].answer.push(answer)
				}
			}
				
			this.$forceUpdate();
		},
		//修改习题内容 答案 解析
		change_topic_content_answer_analysis(type,index,change_type){
			// type  'new'--富文本创建 creat_topic_dia_lsit 
			//  'choose'---选择的题型 choosed_topic_list
			//change_type 修改的类型 'content'  'answer' 'analysis'
			// index---索引 
			let _this=this
			
			_this.edit_topic_dia=true
			_this.edit_topic_dia_type=type
			_this.edit_topic_dia_index=index
			_this.edit_topic_dia_change_type=change_type
			let str=''
			if(_this.edit_topic_dia_type=='new'){
				if(_this.edit_topic_dia_change_type=='content'){
					 str=_this.creat_topic_dia_lsit[_this.edit_topic_dia_index].content||''
				}else if(_this.edit_topic_dia_change_type=='answer'){
					str=_this.creat_topic_dia_lsit[_this.edit_topic_dia_index].answer||''
				}else{
					str=_this.creat_topic_dia_lsit[_this.edit_topic_dia_index].analyzing||''
				}
				// console.log(_this.creat_topic_dia_lsit[_this.edit_topic_dia_index])
				

			}else if(_this.edit_topic_dia_type=='edit_1'){
			
				if(_this.edit_topic_dia_change_type=='content'){
					 str=_this.creat_topic_dia_lsit_edit[0].content||''
				}else if(_this.edit_topic_dia_change_type=='answer'){
					str=_this.creat_topic_dia_lsit_edit[0].answer||''
				}else{
					str=_this.creat_topic_dia_lsit_edit[0].analyzing||''
				}
				// console.log(_this.creat_topic_dia_lsit[_this.edit_topic_dia_index])
				

			}else{
				if(_this.edit_topic_dia_change_type=='content'){
					str=_this.creat_topic_dia_lsit[_this.choosed_topic_list].content||''
				}else if(_this.edit_topic_dia_change_type=='answer'){
					str=_this.creat_topic_dia_lsit[_this.choosed_topic_list].answer||''
				}else{
					str=_this.creat_topic_dia_lsit[_this.choosed_topic_list].analyzing||''

				}
				// console.log(_this.choosed_topic_list[_this.edit_topic_dia_index])

			}
			setTimeout(function(){
				_this.$refs.mychild_edit.setContent1(str);
			},200)
			
	

		},
		confirm_edit_topic(){
			// console.log(this.$refs.mychild_edit.getContent())
			
			// edit_topic_dia_type  'new'--富文本创建 creat_topic_dia_lsit 
			//  'choose'---选择的题型 choosed_topic_list
			// edit_topic_dia_index---索引 
			//change_type 修改的类型 'content'  'answer' 'analysis'
			let str=this.$refs.mychild_edit.getContent()
			if(this.edit_topic_dia_type=='new'){
				if(this.edit_topic_dia_change_type=='content'){
					
					this.creat_topic_dia_lsit[this.edit_topic_dia_index].content=str
				}else if(this.edit_topic_dia_change_type=='answer'){
					this.creat_topic_dia_lsit[this.edit_topic_dia_index].answer=str
				}else{
					this.creat_topic_dia_lsit[this.edit_topic_dia_index].analyzing=str
				}
				// console.log(this.creat_topic_dia_lsit[this.edit_topic_dia_index])
				

			}else if(this.edit_topic_dia_type=='edit_1'){  //选择好的习题列表编辑
				
				if(this.edit_topic_dia_change_type=='content'){
				
					this.creat_topic_dia_lsit_edit[0].content=str
				}else if(this.edit_topic_dia_change_type=='answer'){
					this.creat_topic_dia_lsit_edit[0].answer=str
				}else{
					this.creat_topic_dia_lsit_edit[0].analyzing=str
				}
				// console.log(this.choosed_topic_list[this.edit_topic_dia_index])

		
			}
			else{
				if(this.edit_topic_dia_change_type=='content'){
				
					this.choosed_topic_list[this.edit_topic_dia_index].content=str
				}else if(this.edit_topic_dia_change_type=='answer'){
					this.choosed_topic_list[this.edit_topic_dia_index].answer=str
				}else{
					this.choosed_topic_list[this.edit_topic_dia_index].analyzing=str
				}
				// console.log(this.choosed_topic_list[this.edit_topic_dia_index])

			}
			this.edit_topic_dia=false

		},
		// 返回
		back_to_assign_homework(){
        //   console.log(this.homework_list)
        // return
          this.$router.push(
          {
            name:'/homework/assign_homework',
            params:{
              list:this.homework_list,
              obj:this.obj
            }
          
          })
      },
		//分类习题
		formatting_topic(){
			// alert(1)
			let choosed_topic_list=this.choosed_topic_list
			// console.log(choosed_topic_list)
			// console.log(question_type)
			let arr=this.choosed_topic_list_up
			for(let i in choosed_topic_list){
				for(let j in arr){
					if(choosed_topic_list[i].type_id==arr[j].id&&arr[j].topicList.indexOf(choosed_topic_list[i])==-1){
						arr[j].topicList.push(choosed_topic_list[i])
					}
				}
			}
			// console.log(arr)
			for(let i in arr){
				if(arr[i].topicList.length>0){
					this.activeName[0]=arr[i].name
					// console.log(this.activeName)
					break;
				}
			}
			
			// console.log( this.choosed_topic_list_up)
		},

		save_homework(){
			if(this.chapter_code){
				// this.choose_topic_dia=true
			}else{
				this.$message({
					type:'error',
					message:'请先选择章节',
					durtion:1500,
					showClose: true,
				})
				return
			}
			// console.log(this.choosed_topic_list)
			let choosed_topic_list=this.choosed_topic_list
			let question_type=JSON.parse(JSON.stringify(this.question_type)) 
			question_type.splice(0,1)
			// console.log(question_type)
			let arr=[]

			for(let i in question_type){
				arr.push({
					name:question_type[i].n,
					id:question_type[i].id,
					is_unique:question_type[i].s,
					topicList:[]
				})
			}
			for(let i in choosed_topic_list){
				for(let j in arr){
					if(choosed_topic_list[i].type_id==arr[j].id){
						arr[j].topicList.push(choosed_topic_list[i])
					}
				}
			}
			for(let i=0;i<arr.length;i++){
				if(arr[i].topicList.length==0){
					arr.splice(i,1)
					i--
				}
			}
			let formData = new FormData();
			let url="/school/Homework/addHomework"
			if(this.$route.params.type=='edit'){
				if(this.$route.params.item.heat>0){
						
				}else{
					url="/school/Homework/editHomework"
					formData.append("id", this.$route.params.item.homework_id);
				}
			}
			 formData.append("textbook_guid", sessionStorage.text_book_guid);
			formData.append("content", JSON.stringify(arr));
			formData.append("chapter_code", this.chapter_code);
			formData.append("title", this.homework_name);
			formData.append("status",this.topic_status);
			formData.append("from",JSON.parse(sessionStorage.userInfo).school.name);
		
			this.axios.post(url, formData).then(res => {
				if (res.data.code == 1) {
					this.$message({
					message: res.data.msg,
					type: "success"
					,duration:1500,showClose: true
					});
					console.log(res.data.data)
                    let obj={
                        id:res.data.data.data.id,
                        homework_uuid:res.data.data.data.uuid,
                        title:res.data.data.data.title,
						send_to:this.$route.query.is_course_type
                    }
                    // console.log(this.$route.query.is_course_type)
                    let arr_homework=[]
                    arr_homework=JSON.parse(sessionStorage.content_json)
                    // console.log(arr_homework.b)
					arr_homework.homework.push(obj)
                    // if(this.$route.query.is_course_type=='b'){
                    //     arr_homework.b.uuid.push(obj)
                    // }else if(this.$route.query.is_course_type=='m'){
                    //       arr_homework.m.uuid.push(obj)
                    // }else if(this.$route.query.is_course_type=='a'){
                    //       arr_homework.a.uuid.push(obj)
                    // }
                    sessionStorage.content_json=JSON.stringify(arr_homework)
                    this.$router.go(-1)
					// if(this.$route.params.type=='add'||this.$route.params.type=='edit'){
					// 	this.$router.go(-1)
					// 	return
					// }
					// this.homework_list.push(res.data.data.data)
					// this.$router.push(
					// {
					// 	name:'/homework/assign_homework',
					// 	params:{
					// 	list:this.homework_list,
					// 	obj:this.obj
					// 	}
					
					// })
				}
			});

		},

	}
};
</script>
<style>
	.homework_edit_choose_topic .el-dialog__footer{
		text-align: center !important;
	}
	.add_course_info_head_course_name_add_name .el-input__inner{
		border-color: transparent !important;
		background:#F3F3F3;
		border-radius: 20px 0px 20px 2px;
		text-align: center;
		font-size: 14px !important;
		height: 40px !important;
	}
   .add_course_info_head_course_name_add_name.el-checkbox__label{
     font-size: 12px !important;
   }
    .area_popper   .popper__arrow::after{
        border-bottom-color: #FF9B36 !important;  
   }
   .area_popper{
        border-color: #FF9B36;
        width: 300px;
        height: 400px;
        padding-right: 0;
		overflow: auto;
		font-size: 16px;
		line-height: 16px;
        
   }
   .homework_edit_choose_topic{
	 	width: calc(100vw - 720px);
		border-radius: 12px;
		/* height: 90vh; */
		overflow: hidden;
		margin-top: 5vh !important;
   }
   .homework_edit_choose_topic .el-dialog__body{
	   background: #F2F2F2;
	   
   }
    .homework_creat_choose_topic .el-dialog__body:nth-of-type(2){
	   background: #ffffff;
	   
   }
    .course_search .el-input-group__append{
    border-radius: 0 20px 20px 0;
  }
  .course_search .el-input__inner{
    border-radius: 20px 0 0 20px;
    background: #F8F8F8;
    height: 40px !important;
    font-size: 14px !important;
  }
  .course_search .el-input{
    height: 40px;
  }
  .area_popper_course   .popper__arrow::after{
        border-bottom-color: #FF9B36 !important;  
   }
   .area_popper_course{
        border-color: #FF9B36;
        width: 150px;
        /* height: 400px; */
        padding-right: 0;
        
   }
    .course_creat_sort_options > div{
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      height: 35px;
      line-height: 35px;
      width: 138px;
      cursor: pointer;
   }
   .course_creat_sort_options_disable{
     color: #999999 !important;
     cursor: auto !important;
     
   }
   .course_creat_sort_options_disable:nth-of-type(2n){
     border-top: 1px solid #999999;
   }
   .color_active{
      color: #FF9B36 !important;
   }
  
</style>
<style scoped>
	.wrapper{
		/* background: red; */
		width: 100%;
		height: 100%;
	}
	.head{
		padding: 16px 24px;
		background: #fff;
		border-radius: 12px;
	}
	.head_top{
		height: 32px;
		line-height: 32px;
		display: flex;
		justify-content: space-between;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1A1A1A;
		align-items: center;
		margin-bottom: 18px;
	}
	.head_top img{
		display: block;
		cursor: pointer;
	}
	.sav_homework{
		height: 32px;
		background: #69B4FF;
		border-radius: 8px;
		line-height: 32px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		padding: 0 20px;
		cursor: pointer;
	}
	.add_course_info_head_course_name{
		display: flex;
		justify-content: space-between;
		justify-items: center;
		height: 40px;
		line-height: 40px;
	}
	.add_course_info_head_course_name_add_name > div:nth-of-type(1){
		width: 120px;
	}

	.add_course_info_head_course_name_myself{
		font-size: 12px !important;
	}
	.chapter_bar{
		height: 16px;
		/* font-size: 16px; */
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		font-size: 16px;
		padding: 10px;
		cursor: pointer;
		background: #F8F8F8;
		line-height: 16px;
		border-radius: 10px;
		margin-top: 2px;
	}
	.content{
		height: calc(100vh - 330px);
		/* background: red; */
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
	}
	.content_l{
		width: 824px;
		border-radius: 12px;
		background: #ffffff;
		overflow: hidden;
		padding:16px;
		box-sizing: border-box;
		
	}
	.content_l_top{
		height: 32px;
		margin-bottom: 16px;
		display: flex;
		justify-content: space-between;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1A1A1A;
		line-height: 32px;
	}
	.conent_r{
		width: 360px;
		border-radius: 12px;
		background: #FFFFFF;
		padding:16px;
		box-sizing: border-box;
		height: calc(100vh - 330px);
		overflow: hidden;
	}
	.get_topic{
		display: flex;
	}
	.get_topic >div{
		height: 32px;
		background: #69B4FF;
		border-radius: 8px;
		line-height: 32px;
		padding:0 20px;
		cursor: pointer;
		margin-left: 24px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}
	.content_topic_list{
		height:calc(100vh - 412px);
		overflow: auto;
		/* display: flex;
		flex-wrap: wrap; */
	}
	.no_list_img{
		background:url(../../assets/images/course_2.0/老师.png);
		width:100%;
		height:100%;
		background-repeat: no-repeat;
		background-position: 50% 50%;
		background-size: 200px auto;
	}
	.topic_num{
		background: #69B4FF;
		border-radius: 10px;
		padding: 0 13px;
		height: 20px;
		line-height: 20px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}
	.content_head{
    height: 60px;
    font-size: 16px;
    background: white;
    overflow: hidden;
    border-radius: 12px;
    color: #333333;
	 margin: 15px 0;
   
  }
  .course_type_box{
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    height: 30px;
    margin: 15px 0;
  }
  .course_type_box li{
    cursor: pointer;
  }
  .course_type_line{
    width: 36px;
    height: 5px;
    background: #54A9FD;
    border-radius: 3px;
    margin: 3px auto;
  }
  .choose_topic_box{
	  background: #F2F2F2;
	 overflow: hidden;
  }
	.topic_type_list_item_box{
		display: flex;
		flex-wrap: wrap;
		
	}
	.topic_type_list_item_box >div{
		background: transparent;
		border-radius: 8px;
		padding: 0 20px;
		height: 36px;
		line-height: 36px;
		cursor: pointer;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1A1A1A;
		margin-bottom: 5px;
	}
	.topic_type_active{
		background: #54A9FD !important;
		color: #FFFFFF !important;
	}
	 .course_box{
     border-radius: 12px;
     margin-top:14px ;
  }
  .content_head{
    height: 60px;
    font-size: 16px;
    background: white;
    overflow: hidden;
    border-radius: 12px;
    color: #333333;
   
  }
  .course_type_box{
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    height: 30px;
    margin: 15px 0;
  }
  .course_type_box li{
    cursor: pointer;
  }
  .course_type_line{
    width: 36px;
    height: 5px;
    background: #54A9FD;
    border-radius: 3px;
    margin: 3px auto;
  }
  .course_box_head{
    
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    justify-content: space-between;
    margin: 14px 16px 17px 18px;
    height: 40px;
	line-height: 40px;
  }
  .creat_course{
    /* width: 78px; */
    height: 36px;
    background: #FF9B36;
    border-radius: 10px;
    line-height: 36px;
    text-align: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
     margin-left: 16px;
    padding: 0 10px;
  }
  .course_search{
    height: 40px;
   
  }
  .course_box{
    height:calc( 100vh - 246px);
    background: #ffffff;
    overflow: hidden;
	height: 40px;
	line-height: 40px;
  }
  .course_creat_sort{
    display: flex;
    justify-items: center;
  }
  .topic_content{
	  background: #FFFFFF;
	  overflow: hidden;
	  margin-top: 10px;
	  box-shadow: 0px 0px 6px 0px rgba(204, 204, 204, 0.5);
	border-radius: 6px 20px 20px 6px;
  }
   .course_page{
    margin-top:5px;
	text-align: right;
  }
  .course_creat_sort_btn{
    height: 36px;
    background: #F8F8F8;
    border-radius: 10px;
    padding: 0 15px;
    line-height: 36px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
	margin: 2px 0;
  }
  .topic_list{
	  height: calc(100vh - 540px);
	  background: #FFFFFF;
	  overflow: auto;
	  margin: 0 16px 0 18px;
  }
  .topic_list_item{
		padding: 16px;
		border: 4px solid #69B4FF;
		box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
		border-radius: 6px 20px 20px 6px;
		/* height: 264px;
		overflow: hidden; */
		margin-bottom: 20px;
		cursor: pointer;
  }
  .topic_content_html{
	  /* padding: 16px; */
	  height: 150px;
	  overflow: auto;
  }
  .topic_answer_analyzing{
	background: #F2F2F2;
	border-radius: 4px;
	padding: 10px;
  }
  .topic_info{
	  display: flex;
	  /* justify-content: space-between; */
	  font-size: 16px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: #000000;
	margin-top: 10px;
	height: 26px;
	line-height: 26px;
  }
  .topic_info>div{
	  margin-right: 20px;
  }
	.add_topic{
		height: 20px;
		position: relative;
	}
	.add_topic>div{
		position: absolute;
		right: 0;
		top: 0;
	}
	.add_topic img{
		display: block;
		width:20px;
		height: 20px;
	}
	.topic_info_edit{
		margin-left: auto;
		display: flex;
	}
	.topic_info_edit_img img{
		display: block;
		width: 24px;
		height: 24px;
		cursor: pointer;
		margin: 1px 0 1px 20px;
	}
	.content_topic_list_item{
		width: 36px;
		height: 36px;
		background: #E1F0FF;
		border: 1px solid #69B4FF;
		border-radius: 2px;
		margin-right: 15px;
		margin-bottom: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #69B4FF;
		line-height: 36px;
		text-align: center;
		cursor: pointer;
		
	}

	.edit_txt_content_ifarm{
		height: 80vh;
	}
	.creat_topic_dia_list_item{
		border: 4px solid #69B4FF;
		box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
		border-radius: 6px 20px 20px 6px;
		padding: 16px;
		margin-bottom: 20px;


	}
	.creat_topic_dia_list_item_head{
		display: flex;
	}
	.creat_topic_dia_list_item_head >div:nth-of-type(1){
		margin-right: 20px;
	}
	.creat_topic_dia_list_item_head_del{
		margin-left: auto;
	}
	.creat_topic_dia_list_item_head_del img{
		display: block;
		width: 24px;
		height: 24px;
		cursor: pointer;
	}
	.creat_topic_dia_topic_content{
	
		max-height: 150px;
		overflow: auto;
		cursor: pointer;
		margin: 10px 0;
	}
	.creat_topic_dia_topic_analysis{
		padding: 10px;
		background: #FFFFFF;
		border: 1px solid #DFDFDF;
		border-radius: 12px;
		height: 120px;
		overflow: auto;
		cursor: pointer;
	}
	.creat_topic_dia_topic_answer_title{
		margin-bottom: 10px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #1A1A1A;
	}
	.creat_topic_dia_topic_answer_choice{
		display: flex;
		margin-bottom: 10px;
	}
	.creat_topic_dia_topic_answer_choice>div{
		width: 32px;
		height: 32px;
		background: #CCCCCC;
		border-radius: 8px;
		text-align: center;
		line-height: 32px;
		color: #ffffff;
		font-size: 20px;
		cursor: pointer;
		margin-right: 10px;
	}

	
	

</style>
